"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenService = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _internals = require("./internals");
var _storage = require("./storage");
var _TokenService;
class TokenService {
  constructor() {
    (0, _defineProperty2.default)(this, "oidcTokenStorage", new _storage.OidcTokenStorage());
    // TODO: remove when this is fixed: https://github.com/microsoft/TypeScript/issues/53305
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- false positive
    TokenService.instance ??= this;

    // eslint-disable-next-line no-constructor-return -- needed for the singleton pattern
    return TokenService.instance;
  }
  static getInstance() {
    return new this();
  }

  // TODO: This is kind of weird flow. customerId is not always known, but could be available inside cookies. Should we somehow provide a way to get userId from that?
  async getAuthorizationToken(customerId) {
    let token = null;
    const userId = typeof customerId === 'string' ? Number(customerId) : customerId;
    if (userId !== _constants.NOT_LOGGED_IN_USER_ID) {
      token = await this.getTokenServiceUserToken();
      if (!token) {
        token = this.getSessionStorageToken();
      }
    }
    if (!token) {
      token = await this.getTokenServicePublicToken();
    }
    if (!token) {
      throw new Error('Token is missing!');
    }
    return token;
  }
  getSessionStorageToken() {
    const token = this.oidcTokenStorage.getAccessToken();
    if (token) {
      return token.toString();
    }
    return null;
  }
  async getTokenServiceUserToken() {
    const result = await TokenService.userTokenClient.getToken();
    return result?.Token ?? null;
  }
  async getTokenServicePublicToken() {
    const result = await TokenService.publicTokenClient.getToken();
    return result?.Token ?? null;
  }
}
exports.TokenService = TokenService;
_TokenService = TokenService;
(0, _defineProperty2.default)(TokenService, "instance", void 0);
// Create token clients just once - no need to create them every time TokenService is created
(0, _defineProperty2.default)(TokenService, "userTokenClient", new _internals.UserTokenClient());
(0, _defineProperty2.default)(TokenService, "publicTokenClient", new _internals.PublicTokenClient());
